export const memoForCallbacks = (actualFn, areEqual)=>{
    const lastResultLookup = {};
    const lastArgsLookup = {};
    return (args)=>{
        const err = new Error();
        const uniqHash = err.stack || '';
        const lastArgs = lastArgsLookup[uniqHash];
        if (areEqual(lastArgs, args)) {
            return lastResultLookup[uniqHash];
        }
        lastResultLookup[uniqHash] = actualFn(args);
        lastArgsLookup[uniqHash] = args;
        return lastResultLookup[uniqHash];
    };
};
